import * as React from "react";

interface IProps {
    text: string;
    splitChar: string;
    keepSplitChar?: boolean;
    removeEmptyText?: boolean;
    separator?: React.ReactNode;
}

export const ReactSplitString: React.FC<IProps> = ({ text, splitChar, separator, keepSplitChar, removeEmptyText }) => {

    if (text == null || text.length == 0 || splitChar == null || splitChar.length == 0)
        return null;

    var splitText = (removeEmptyText)
        ? text.split(splitChar).filter(p => p != "")
        : text.split(splitChar);

    return (
        <>
            {
                splitText.map((v, index) => (
                    <React.Fragment key={index}>
                        {v.trim()}{keepSplitChar && splitChar}
                        {index < splitText.length - 1 ? (separator ?? null) : null}
                    </React.Fragment>)
                )
            }
        </>
    );
};
